import { render, staticRenderFns } from "./CourseTypeIcon.vue?vue&type=template&id=3ce3714c&scoped=true"
import script from "./CourseTypeIcon.vue?vue&type=script&lang=js"
export * from "./CourseTypeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce3714c",
  null
  
)

export default component.exports